<template>
  <multiselect
    :value="selectedItems"
    @input="input"
    label="text"
    :placeholder="placeholder"
    track-by="value"
    :options="options"
    :multiple="true"
    :disabled="disabled"
  />
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  props: {
    disabled: Boolean,
    placeholder: String,
    value: Array,
    options: Array,
  },
  components: {
    Multiselect
  },
  data: () => ({
    selectedItems: [],
  }),
  created() {
    const { options, value } = this;
    this.selectedItems = options.filter(el => (Array.isArray(value) ? value : []).includes(el.value));
  },
  methods: {
    input(val) {
      this.selectedItems = val;
      this.$emit('input', this.selectedItems.map(({ value }) => value));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/MultiSelectField.vue